<template lang="pug">
v-layout(align-start)
  div
    v-card.mb-2(color='grey_1')
      v-app-bar()
        v-toolbar-title Total Por Pagar:
        v-spacer 
        h3 BsS {{totalBs}} 
        v-spacer
        h3 $ {{totalDolar}}
        v-dialog(ref='dialog1' v-model='modalDate1' :return-value.sync='date' readonly persistent width='300px')
          template(v-slot:activator='{ on }')
            v-text-field.mt-6.mx-4( v-model='fechaPago' label='Fecha de pago' prepend-icon='event' readonly dense outlined v-on='on')
          v-date-picker( v-model='fechaPago' locale="ES")
            v-spacer
            v-btn(small dark color='red' @click='modalDate1 = false') Cancelar
            v-btn(small dark color='success' @click='$refs.dialog1.save(date)') Ok
        v-btn.mx-2(@click='buscarCXC()' color='primary' dark) PROCESAR
        v-btn(@click='clear()' color='primary' dark) LIMPIAR
    
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='arregloCXP' :items='arregloCXP' :search='search' sort-by='numFactura' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Estados de Cuentas por Pagar
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialog', persistent='', max-width='40%')
              template(v-slot:activator='{ on }')
                v-btn(@click='exportPDF()' small color='red')
                  v-icon(dark) mdi-pdf-box
            CuentaXPagarM(:dialog='dialog' :editedIndex='editedIndex' @close='close' :read='read' :FormPadre='form' @save='listarCuentasXPagar' @edited='listarCuentasXPagar')
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(v-if='item.numFactura !== "Sin Nro.Factura." && item.estatus !== "Cancelada"' color='success' @click='editItem(item)' v-on="on") mdi-cash-usd
            | Pagar
        template(v-slot:no-data='')
          h1 No hay Cuentas por Pagar Asociadas
</template>

<script>
import Api from '@/services/methods'
import CuentaXPagarM from '../components/modals/CuentaXPagarM'
import Jspdf from 'jspdf'
// eslint-disable-next-line no-unused-vars
import JspdfAutotable from 'jspdf-autotable'
export default {
  data: () => ({
    dialog: false,
    read: false,
    loading: true,
    dialog1: false,
    modalDate1: false,
    fechaPago: '',
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: 'Número Factura', align: 'left', value: 'numFactura' },
      { text: 'Proveedor', value: 'idProveedor.nombre' },
      { text: 'Fecha Vencimiento', value: 'idCompra.fechaVencimiento' },
      { text: 'Debito', value: 'debito' },
      { text: 'Credito', value: 'credito' },
      { text: 'Deuda $', value: 'deudaDolar' },
      { text: 'Concepto', value: 'idConcepto.nombre' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    search: '',
    cxp: [],
    arregloCXP: [],
    totalBs: 0,
    totalDolar: 0,
    proveedores: [],
    permisosRuta: {},
    editedIndex: -1,
    estatus: [ { value: false, text: 'No' }, { value: true, text: 'Si' } ],
    form: {},
    defaultItem: {}
  }),
  components: {
    CuentaXPagarM
  },
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.initialize()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta == "Almacen")
  },
  methods: {
    initialize () {
      this.listarCuentasXPagar()
    },
    // validarCrear(){
    //   return this.permisosRuta.accion.includes('Crear')
    // },

    // validarModificar(){
    //   return this.permisosRuta.accion.includes('Modificar')
    // },

    // validarEliminar(){
    //   return this.permisosRuta.accion.includes('Eliminar')
    // },

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm')
    },
    decimal (val) {
      return Number.parseFloat(val).toFixed(2)
    },
    listarCuentasXPagar () {
      Api.get('cxp')
        .then(response => {
          this.cxp = response.data
          console.log(response.data)
          this.clientesCXP(this.cxp)
          this.cxp.map((data, i) => {
            if (data.credito === 0) {
              this.cxp[i].estatusPago = 'Pendiente'
            } else {
              this.cxp[i].estatusPago = 'Cancelada'
            }
            data.fechaRegistro = this.formato(data.fechaRegistro)
            data.fechaFactura = this.formato(data.fechaCierreFactura)
            // data.idCompra.fechaVencimiento = this.formato(data.idCompra.fechaVencimiento)
            // data.debito = this.decimal(data.debito)
            // data.credito = this.decimal(data.credito)
            // data.saldo = this.decimal(data.saldo)
            this.cxp[i].deudaDolar = 0
            if (data.idCompra.tasaCompra) {
              if (data.idCompra.tasaCompra > 0 && data.credito > 0) {
                this.cxp[i].deudaDolar = data.credito / data.idCompra.tasaCompra
              }
            } 
            
          })
          this.loading = false
          this.arregloCXP = this.cxp
          this.calcularDeuda()
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    clientesCXP (cxp) {
      cxp.map(data => {
        if (data.idProveedor) {
          if (this.proveedores.length === 0) {
            this.proveedores.push(data.idProveedor)
          } else {
            let bool = false
            for (let i = 0; i < this.proveedores.length; i++) {
              if (data.idProveedor._id !== this.proveedores[i]._id) {
                bool = true
              } else {
                bool = false
                break
              }
            }
            if (bool) {
              this.proveedores.push(data.idProveedor)
            }
          }
        }
      })
    },

    buscarCXC () {
      if (this.fechaPago != "") {
        this.arregloCXP = this.cxp.filter(pago => {
          if (pago.idCompra.fechaVencimiento) {
            let f1 = new Date(pago.idCompra.fechaVencimiento)
            let f2 = new Date(this.fechaPago)

            return f1 <= f2
          }
        }) 
      } else {
        this.arregloCXP = this.cxp
      }
      this.calcularDeuda()
    },

    clear() {
      this.fechaPago = ""
      this.buscarCXC()
    },

    calcularDeuda () {
      this.totalBs = 0
      this.totalDolar = 0
      this.arregloCXP.map(data => {
        this.totalBs += data.credito
        this.totalDolar += data.deudaDolar
      })
      this.totalBs = Number.parseFloat(this.totalBs).toFixed(2)
      this.totalDolar = Number.parseFloat(this.totalDolar).toFixed(2)
    },

    editItem (item) {
      this.editedIndex = this.cxp.indexOf(item)
      this.form = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    exportPDF () {
      var columns = [
        { title: 'N° Factura', dataKey: 'numF' },
        { title: 'Fecha Registro', dataKey: 'fechaR' },
        { title: 'Fecha Vencimiento', dataKey: 'fechaV' },
        { title: 'Neto', dataKey: 'neto' },
        { title: 'Saldo', dataKey: 'saldo' }
      ]

      let contenido = []
      let acumTotal = 0

      var doc = new Jspdf('l', 'pt')
      doc.setFontSize(10)
      doc.setFont('helvetica')
      doc.setFontType('bold')
      doc.text(50, 30, 'Cuentas por Pagar a Proveedores')
      for (let i = 0; i < this.proveedores.length; i++) {
        for (let j = 0; j < this.cxp.length; j++) {
          if (this.cxp[j].idProveedor) { 
            if (this.proveedores[i]._id === this.cxp[j].idProveedor._id) {
              let sal = this.cxp[j].credito.toFixed(2) - this.cxp[j].debito.toFixed(2)
              contenido.push({
                numF: this.cxp[j].numFactura,
                fechaR: this.cxp[j].fechaRegistro,
                fechaV: this.cxp[j].fechaVencimiento,
                // observacion: this.cxp[j].idVenta.observacion,
                neto: this.cxp[j].credito.toFixed(2),
                saldo: sal
              })
            }
          }
        }

        let acum = 0
        for (let k = 0; k < contenido.length; k++) {
          acum += contenido[k].saldo
        }

        contenido.push({
          numF: this.proveedores[i].nombre,
          neto: 'TOTAL :',
          saldo: acum
        })

        // acumTotal += acum

        // doc.text(50, doc.autoTableEndPosY() + 35, this.clientes[i].nombre)
        doc.autoTable(columns, contenido, {
          theme: 'grid',
          margin: { top: 60 },
          styles: { lineWidth: 0, lineColor: 10, font: 'helvetica', fontStyle: 'bold', textColor: 20 },
          pageBreak: 'avoid',
          headStyles: { fillColor: [255, 255, 255], lineWidth: 1 },
          didParseCell: function (data) {
            var rows = data.table.body
            if (data.row.index === rows.length - 1) {
              data.cell.styles.fillColor = [192, 192, 192]
            }
          }
          // startY: doc.autoTableEndPosY() + 40
        })
        contenido = []
      }

      doc.setProperties({
        title: 'Factura'
      })
      doc.output('dataurlnewwindow')
    }
  }
}
</script>
